import React, { createContext, useState, useEffect, useContext } from 'react';

const SharedDataContext = createContext();

export const useSharedDataContext = () => {
    return useContext(SharedDataContext);
}

const SharedDataProvider = ({ children }) => {
    const [sharedData, setSharedData] = useState(() => {
        const storeData = sessionStorage.getItem('sharedData');
        return storeData ? JSON.parse(storeData) : {};
    });


    useEffect(() => {
        sessionStorage.setItem('sharedData', JSON.stringify(sharedData));
    }, [sharedData])

    return (
        <SharedDataContext.Provider value={{ sharedData, setSharedData }} >
            {children}
        </SharedDataContext.Provider>
    )
};

export default SharedDataProvider;